import {
  getSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPost,
  GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostData,
  GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { queryClient } from '@common/config/api/queryClient'

export const useSubjectReassignementMutation = (): UseMutationResult<
  GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostResponse,
  AxiosError<HTTPValidationError>,
  GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostData
> => {
  return useMutation<
    GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostResponse,
    AxiosError<HTTPValidationError>,
    GetSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPostData
  >({
    mutationFn: async (query) => {
      const response = await getSubjectReassignmentEsignStudiesStudyIdSubjectsSubjectIdSubjectReassignPost({
        path: query.path,
        body: query.body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: (_, query) => {
      queryClient.invalidateQueries({ queryKey: ['SubjectsList'] })
      queryClient.invalidateQueries({ queryKey: ['TimePointsDetails'] })
      queryClient.invalidateQueries({ queryKey: ['study', query.path.study_id, 'subject'] })
    },
  })
}
